var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Emoji } from "emoji-mart";
import { FormattedMessage } from "@irati/utils/lang";
import { ResponsiveFlexWrapper, FlexWrapper, Flex, StyledPara } from "./styled";
var ActivationSteps = /** @class */ (function (_super) {
    __extends(ActivationSteps, _super);
    function ActivationSteps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActivationSteps.prototype.render = function () {
        var isMobile = this.props.isMobile;
        var step1Text = isMobile ? "medical.activation.step.text1" : "medical.activation.desktopStep.text1";
        var step2Text = isMobile ? "medical.activation.step.text2" : "medical.activation.desktopStep.text2";
        var step3Text = isMobile ? "medical.activation.step.text3" : "medical.activation.desktopStep.text3";
        var step4Text = isMobile ? "medical.activation.step.text4" : "medical.activation.desktopStep.text4";
        return (React.createElement(ResponsiveFlexWrapper, null,
            React.createElement(FlexWrapper, null,
                React.createElement(Flex, null,
                    React.createElement(Emoji, { emoji: { id: "one" }, size: 14, set: "apple" }),
                    React.createElement(StyledPara, null,
                        React.createElement(FormattedMessage, { id: step1Text }))),
                React.createElement(Flex, null,
                    React.createElement(Emoji, { emoji: { id: "two" }, size: 14, set: "apple" }),
                    React.createElement(StyledPara, null,
                        React.createElement(FormattedMessage, { id: step2Text }))),
                React.createElement(Flex, null,
                    React.createElement(Emoji, { emoji: { id: "three" }, size: 14, set: "apple" }),
                    React.createElement(StyledPara, null,
                        React.createElement(FormattedMessage, { id: step3Text }))),
                React.createElement(Flex, null,
                    React.createElement(Emoji, { emoji: { id: "four" }, size: 14, set: "apple" }),
                    React.createElement(StyledPara, null,
                        React.createElement(FormattedMessage, { id: step4Text }))))));
    };
    return ActivationSteps;
}(PureComponent));
export default ActivationSteps;
